"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitions = exports.sizes = void 0;
exports.sizes = {
    mobile: '480px',
    tablet: '864px',
    laptop: '1200px',
};
exports.transitions = {
    fast: 'all 0.1s ease-in-out',
};
//# sourceMappingURL=constants.js.map